import React from 'react';
import { Button } from '@components';
import { Card, Form, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { PHAMVIHANHNGHE_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    tenPhamViHanhNghe: yup
        .string()
        .required('Tên phạm vi hành nghề không được để trống')
        .max(255, 'Tên phạm vi hành nghề không được vượt quá 255 ký tự')
});

const PhamViHanhNgheEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const params = new URLSearchParams(location.search.substring(1));
    const itemId = params.get('id');

    const itemQuery = useQuery(['phamViHanhNghe', itemId], () => Get(PHAMVIHANHNGHE_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });

    const editMutation = useMutation((value) => Put(PHAMVIHANHNGHE_API.UPDATE_ITEM, itemId, value));

    const handleEdit = (values) => {
        editMutation.mutate(values, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.setQueryData(['phamViHanhNghe', itemId], values);
                    history.push(URI_INTERNAL.PHAMVIHANHNGHE_PATH);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return <div>Có lỗi xảy ra hoặc không tìm thấy phạm vi hành nghề</div>;
    }

    const currentData = itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Sửa phạm vi hành nghề</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        tenPhamViHanhNghe: currentData.tenPhamViHanhNghe || currentData.TenPhamViHanhNghe || ''
                    }}>
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên phạm vi hành nghề',
                                        name: 'tenPhamViHanhNghe',
                                        value: values.tenPhamViHanhNghe,
                                        onChange: handleChange,
                                        isInvalid: errors.tenPhamViHanhNghe,
                                        error: errors.tenPhamViHanhNghe
                                    }
                                ]}
                            />

                            <Form.Group className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary">
                                            Cập nhật
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.PHAMVIHANHNGHE_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default PhamViHanhNgheEdit;